import {
  createRoute,
  lazyRouteComponent,
  useParams,
} from '@tanstack/react-router'

import type { CasinoGameSearch } from '../../types/route-search'
import { casinoRoute } from '.'

const Game = lazyRouteComponent(() => import('../../pages/game'))

// One mount per game.
//
// The page is mount-scoped by design: it reads gameId/gameCode from
// window.location.search once (a deliberate workaround for useSearch being empty
// on this lazy route's first render) and launches the game from a mount-only
// effect. TanStack Router keeps the same match mounted when only params change,
// so a game→game navigation — searching from the nav bar while already inside a
// game — swapped the URL but left the previous iframe running, which reads as
// "the game doesn't open".
//
// Router v1.40 predates the `remountDeps: ({ params }) => params` route option
// that exists for exactly this, so the params key reproduces it here. Keep this
// wrapper (or move to remountDeps) if the page ever stops being mount-scoped.
const KeyedGame = () => {
  const { category, game } = useParams({ from: '/casino/$category/$game' })
  return <Game key={`${category}/${game}`} />
}

export const gameRoute = createRoute({
  getParentRoute: () => casinoRoute,
  path: '$category/$game',
  component: KeyedGame,
  validateSearch: (search: Record<string, unknown>): CasinoGameSearch => {
    return {
      gameCode: typeof search.gameCode === 'string' ? search.gameCode : '',
      gameId: typeof search.gameId === 'string' ? search.gameId : '',
      isFavorite:
        typeof search.isFavorite === 'string'
          ? (search.isFavorite as '1' | '0')
          : '0',
      platform: typeof search.platform === 'string' ? search.platform : undefined,
    }
  },
})
